import { Subscription } from 'rxjs/Subscription';
import { Component, OnInit, OnDestroy } from '@angular/core';
import store from './../../../store/store.module';
import {
  EDIT_DELIVERYS_REQUESTED,
  GET_DELIVERYS_REQUESTED
} from './edit.actions';
import * as _ from 'lodash';
import { NotificationService } from '../../../common/services/notification/notification.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Countries } from '../../../common/data/countries';
import {CREATE_CUSTOMER_ADDRESS_REQUESTED, UPDATE_CUSTOMER_ADDRESS_REQUESTED} from "../../customer/edit/edit.actions";
import {DELIVERY_COMP} from "../delivery.const";
@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})
export class EditComponent implements OnInit, OnDestroy {
  public navigationSubscription: Subscription;
  public store = store;
  public COUNTRIES = Countries;
  constructor(private notification: NotificationService, private activeRouter: ActivatedRoute, private router: Router) {
    this.activeRouter = activeRouter;
    this.router = router;
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd) {
        store.dispatch({ type: GET_DELIVERYS_REQUESTED, id: this.activeRouter.snapshot.paramMap.get('id') });
      }
    });
  }
  ngOnInit() {
  }
  ngOnDestroy() {
    if (!_.isUndefined(this.navigationSubscription)) {
      this.navigationSubscription.unsubscribe();
    }
  }

  editDelivery(form, data) {
    if (form.valid) {
      data.delivery_address.phone =  data.delivery_address.phone_arr;
      store.dispatch({ type: EDIT_DELIVERYS_REQUESTED, data: {
        address: data.delivery_address,
        id: data.id,
        note : data.note,
        expected_date: data.expected_date}});
    }
  }

  saveAddressToCustomer(addr, customer, newdata) {
    if (!customer) {
      return;
    }
    if (!customer.id) {
      return;
    }
    Object.keys(addr).forEach(s => {
      if (['customer_id', 'id'].indexOf(s) === -1) {
        addr[s] = newdata[s];
      }
    });
    addr.phone = addr.phone_arr;
    if (addr.id) {
      store.dispatch({
        type: UPDATE_CUSTOMER_ADDRESS_REQUESTED,
        data: _.assign({}, addr, {
          customer_id: customer.id
        }),
        com: DELIVERY_COMP
      });
    } else {
      store.dispatch({
        type: CREATE_CUSTOMER_ADDRESS_REQUESTED,
        data: _.assign({}, addr, {
          customer_id: customer.id
        }),
        com: DELIVERY_COMP
      });
    }
  }
}
